const pageSize = 12;
let currentIndex = 0;
let renderedProducts = 0;
let pageNum = 1;
const LOCAL_STORAGE_KEY = 'wishlist_items';

async function loadOldWishListProducts(rootUrl, wishListProds, pageNumber) {
    if (wishListProds.length < 1) {
      document.getElementById("empty-msg-div").style.display = "flex";
      return;
    }
  
    let productsLiHtml = "";
    document.getElementById("load-more-btn").style.display = "none";
    document.getElementById("wl-loading-div").style.display = "flex";
  
    let productsToFetch;
    let fetchedProducts = 0;
  
    // Continue fetching until you get `pageSize` products or all products are loaded
    while (fetchedProducts < pageSize && currentIndex < wishListProds.length) {
      productsToFetch = wishListProds.slice(currentIndex, Math.min(currentIndex + pageSize - fetchedProducts, wishListProds.length));
  
      const fetchPromises = productsToFetch.map(product => 
        fetch(rootUrl + "/products/" + product.handle + "?view=product-card").then(response => {
          if (!response.ok) {
            console.log(`Response was not ok while looking for product json for handle ${product.handle}`);
            return null;
          }
          if(response.redirected){
            console.log(`Response was redirected while looking for product json for handle ${product.handle}, the product is not active`);
            return null;
          }
          return response.text();
        })
      );
  
      const fetchedHtmlArray = await Promise.all(fetchPromises);
      const validResponses = fetchedHtmlArray.filter(html => html !== null);
  
      productsLiHtml += validResponses.map(responseHtml =>
        "<li class='grid__item scroll-trigger animate--slide-in'>" + responseHtml + "</li>"
      ).join("");
  
      renderedProducts += validResponses.length;
      fetchedProducts += validResponses.length;
      currentIndex += productsToFetch.length;
  
      // Exit loop if there are no more products to fetch
      if (currentIndex >= wishListProds.length) {
        break;
      }
    }
  
    document.getElementById("old-wish-list").innerHTML += productsLiHtml;
    document.getElementById("wl-loading-div").style.display = "none";
  
    pageNumber++;
  
    if (currentIndex < wishListProds.length) {
      document.getElementById("load-more-btn").style.display = "flex";
      document.getElementById("now-showing-number").innerHTML = `You've viewed ${renderedProducts} of ${wishListProds.length - (currentIndex - renderedProducts)} products`;
    } else {
      document.getElementById("load-more-btn").style.display = "none";
    }
  }

function getOfflineWishlistItems() {
  const localStorageValue = window.localStorage.getItem(LOCAL_STORAGE_KEY);

  return localStorageValue ? JSON.parse(localStorageValue) : [];
}



async function loadMoreWishList() {
  try {

    loadOldWishListProducts(window.wishlist.shop_secure_url, window.wishlist.items, pageNum);
  }
  catch (e) {
    document.getElementById("empty-msg-div").style.display = "flex";
    document.getElementById("wl-loading-div").style.display = "none";
    document.querySelector("#empty-msg-div>p").innerHTML = "Error: " + (e.message || e.toString());
  }
}


document.addEventListener("DOMContentLoaded", async function () {

  try {
    if (window.wishlist && window.wishlist.customerLoggedIn && window.wishlist.items) {
      await loadOldWishListProducts(window.wishlist.shop_secure_url, window.wishlist.items, 1);
    } else {
      const offlineWishlistItems = getOfflineWishlistItems();
      window.wishlist.items = offlineWishlistItems;
      await loadOldWishListProducts(window.wishlist.shop_secure_url, window.wishlist.items, 1);
    }
  }
  catch (e) {
    document.getElementById("empty-msg-div").style.display = "flex";
    document.getElementById("wl-loading-div").style.display = "none";
    document.querySelector("#empty-msg-div>p").innerHTML = "Error: " + (e.message || e.toString());
  }

});